import { SessionId, UserId } from '@hc-frontend/core-types';
import { z } from 'zod';

export const LeadIdentifier = z.object({
  sessionId: SessionId,
  userId: UserId,
});

export type LeadIdentifier = z.infer<typeof LeadIdentifier>;
